import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { TrackedArray } from 'tracked-built-ins';

export default class DebugKineticIntegrationLogsIntegrationOutboxLogController extends Controller {
  queryParams = ['searchTerm', 'beginDate', 'endDate', 'Message', 'page'];

  @tracked showJsonModal = false;
  @tracked model = new TrackedArray();
  @tracked displayedValue;
  @tracked searchTerm;
  @tracked beginDate;
  @tracked endDate;
  @tracked page = 1;
  @tracked Message;

  @action
  onShowJsonModal(obj) {
    if (obj == null) {
      return;
    }

    Object.assign(this, {
      showJsonModal: true,
      displayedValue: obj,
    });
  }

  @action
  onParamChange(key, value) {
    this[key] = value;
  }
}
